import {ChangeDetectionStrategy, Component, OnInit, inject, signal} from '@angular/core';
import {Title} from "@angular/platform-browser";

import {PortalConfig} from "@shared/portal-config";

@Component({
    selector: 'app-unauthorised-page',
    templateUrl: './unauthorised-page.component.html',
    styleUrls: ['./unauthorised-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorisedPageComponent implements OnInit {
    private readonly titleService = inject(Title);
    private readonly config = inject(PortalConfig);

    readonly supportMessage = signal<string>('');

    ngOnInit(): void {
        this.titleService.setTitle('Portal - Error');
        this.supportMessage.set(this.config.supportMessage);
    }
}
